import { render, staticRenderFns } from "./Hayat.vue?vue&type=template&id=2eb9c47d&"
import script from "./Hayat.vue?vue&type=script&lang=js&"
export * from "./Hayat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports